import React from 'react';
import Container from '../../components/Container';
import Input from '../../components/Form/Input';
import useForm from '../../hooks/useForm';
import {Form, Submit, MyTable} from './styled';
import Button from '../../components/Button';
import {UserContext} from '../../UserContext';
import {api} from '../../services/api';
import {Checkbox, FormControlLabel, Snackbar} from '@material-ui/core';
import MuiAlert, {AlertProps} from '@material-ui/lab/Alert';
import {GridCellParams, GridColDef, GridRowData, GridRowParams, GridToolbar} from '@material-ui/data-grid';
import Table from '../../components/Table';
import PrintIcon from '@material-ui/icons/Print';
import { DuplicateProps } from '../../interfaces';

function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const columns: GridColDef[] = [
    {
        field: "col1",
        headerName: "Print",
        sortable: false,
        width: 80,
        align: 'center',
        renderCell: (params) => {
            return (
                <div className="d-flex justify-content-between align-items-center" style={{cursor: "pointer"}}>
                    <PrintIcon fontSize="large"/>
                </div>
            );
        }
    },
    {field: 'col2', headerName: 'Nosso Numero', width: 170},
    {field: 'col3', headerName: 'Duplicata', width: 150},
    {field: 'col4', headerName: 'Vencimento', width: 170},
    {field: 'col5', headerName: 'Valor Titulo', width: 170, align: 'right',},
    {field: 'col6', headerName: 'Valor Pago', width: 170, align: 'right',},
    {field: 'col7', headerName: 'Saldo Titulo', width: 170, align: 'right',},
    {field: 'col8', headerName: 'Cliente', width: 150},
    {field: 'col9', headerName: 'Pedido', width: 150},
    {field: 'col10', headerName: 'Data Pedido', width: 150},
    {field: 'col11', headerName: 'NumeroNF', width: 170},
    {field: 'col12', headerName: 'iSituacaoVencimento', width: 170, hide: true,},
    {field: 'col13', headerName: 'iBanco', width: 170, hide: true,},
    {field: 'col14', headerName: 'iStatusTitulo', width: 170, hide: true,},
    {field: 'col15', headerName: 'nValorTitulo', width: 170, hide: true,},
    {field: 'col16', headerName: 'nValorPago', width: 170, hide: true,},
    {field: 'col17', headerName: 'nSaldoTitulo', width: 170, hide: true,},
];

const Duplicate: React.FC = () => {
    document.title = "Duplicatas - Sultan Veste a Casa";

    const [rows, setRows] = React.useState<GridRowData[]>([]);
    const [group, setGroup] = React.useState(false);
    const [error, setError] = React.useState('');

    const cnpj_cpf_code = useForm('notEmpty');
    const {loading, setLoading} = React.useContext(UserContext);

    var formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',    
    });  

    function changeGroup() {
        setGroup(!group);
    }

    async function searchDuplicates() {
        try {
            setLoading(true);
            setRows([]);

            const {data} = await api.post('/duplicates', {
                cnpj_cpf_code: cnpj_cpf_code.value,
                group: group
            });

            const duplicates = data.duplicates.map((el: DuplicateProps, index: number) => {
                return {
                    id: index,
                    col2: el.sNossoNumero,
                    col3: el.sDuplicata,
                    col4: el.dtVctoTit,
                    col5: formatter.format(parseFloat(`${el.nValorTitulo}`)),
                    col6: formatter.format(parseFloat(`${el.nValorPago}`)),
                    col7: formatter.format(parseFloat(`${el.nSaldoTitulo}`)),
                    col8: el.Cliente,
                    col9: el.Pedido,
                    col10: el.DataPedido,
                    col11: el.NumeroNF,
                    col12: el.iSituacaoVencimento,
                    col13: el.iBanco,
                    col14: el.iStatusTitulo,
                    col15: el.nValorTitulo,
                    col16: el.nValorPago,
                    col17: el.nSaldoTitulo,
                }
            });

            setRows(duplicates);
        } catch (error) {
            const result = (error as Error).message;
            setError(result);
        } finally {
            setLoading(false);
        }
    }

    function doSearch(e: React.FormEvent): void {
        e.preventDefault();

        if (cnpj_cpf_code.validate()) {
            searchDuplicates();
        }
    }

    const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setError('');
    };

    function currentlySelected(params?: GridCellParams) {
        var msg = null;

        if(!params) return;
        if (params.colDef.field === 'col1') {
            switch (params.row.col14) {
                case '0':
                    msg = "Aguardando Registro no Banco.";
                    break;
                case '1':
                    msg = "Entrar em Contato com o Setor de Cobrança da Sultan. Cd 1.";
                    break;
                case '2':
                    msg = "Entrar em Contato com o Setor de Cobrança da Sultan. Cd 2";
                    break;
                case '3':
                    msg = "Entrar em Contato com o Setor de Cobrança da Sultan. Cd 3";
                    break;
                case '4':
                    msg = "Aguardar Aviso de Cartório. Cd 4";
                    break;
                case '5':
                    msg = null;
                    break;
                case '6':
                    msg = "Entrar em Contato com o Setor de Cobrança da Sultan. Cd 6";
                    break;
                case '7':
                    msg = null;
                    break;
                case '8':
                    msg = "Entrar em Contato com o Setor de Cobrança da Sultan. Cd 8";
                    break;
                case '9':
                    msg = "Entrar em Contato com o Setor de Cobrança da Sultan. Cd 9";
                    break;
                case '10':
                    msg = "Entrar em Contato com o Setor de Cobrança da Sultan. Cd 10";
                    break;
                default:
                    msg = "Entrar em Contato com o Setor de Cobrança da Sultan. Cd Indefinido";
            }

            if (msg !== null) {
                setError(msg);
                return;
            }

            var url = process.env.REACT_APP_BOLETO;
            url += params.row.col13 === '1' ? "boleto_bb.php?nosso_numero=" : "boleto_bradesco.php?nosso_numero=";

            window.open(url + params.row.col2);
        }
    }

    const rowClassName = (params?: GridRowParams) => {
        if(!params) return '';

        return `super-app-theme--${params.getValue(params.id, 'col12')}`;
    }

    return (
        <Container>
            <Alert severity="info">
                Você pode selecionar a opção "Selecionar Grupo" para trazer todas as duplicatas relacionada á esse
                Código ou CNPJ/CNPJ.
            </Alert>
            <Form className="shadow" onSubmit={doSearch}>
                <Input label="Código do Cliente, CPF ou CNPJ" placeholder="Código do Cliente, CPF ou CNPJ" id="cnpj_cpf_code"
                       type="text" {...cnpj_cpf_code}/>
                <Submit>
                    <div>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={group}
                                    onChange={changeGroup}
                                    name="group"
                                    color="primary"
                                />
                            }
                            label="Selecionar Grupo"
                        />
                    </div>                            
                    {loading ? <Button type="submit" disabled>Carregando...</Button> :
                        <Button type="submit">Pesquisar</Button>}
                </Submit>                
            </Form>                
            {rows.length > 0 && 
                <MyTable>
                    <tr>
                        <th>Status</th>
                        <th>Qtd. de Duplicatas</th>
                        <th>Valor em Aberto</th>
                    </tr>                    
                    <tr className="vermelho">
                        <td>Vencidas</td>
                        <td>{rows.filter(el => el.col12 === '1').length}</td>
                        {rows.filter(el => el.col12 === '1').length > 0 ?
                            <td>
                                {formatter.format(rows.filter(el => el.col12 === '1').map(el => el.col17).reduce((el, current) => parseFloat(el) + parseFloat(current)))}
                            </td>
                        :
                            <td>
                                {formatter.format(0)}
                            </td>
                        }                    
                    </tr>   
                    <tr className="amarelo">
                        <td>Vencendo</td>
                        <td>{rows.filter(el => el.col12 === '2').length}</td>
                        {rows.filter(el => el.col12 === '2').length > 0 ?
                            <td>
                                {formatter.format(rows.filter(el => el.col12 === '2').map(el => el.col17).reduce((el, current) => parseFloat(el) + parseFloat(current)))}
                            </td>
                        :
                            <td>
                                {formatter.format(0)}
                            </td>
                        }                    
                    </tr> 
                    <tr className="verde">
                        <td>A Vencer</td>
                        <td>{rows.filter(el => el.col12 === '3').length}</td>
                        {rows.filter(el => el.col12 === '3').length > 0 ?
                            <td>
                                {formatter.format(rows.filter(el => el.col12 === '3').map(el => el.col17).reduce((el, current) => parseFloat(el) + parseFloat(current)))}
                            </td>
                        :
                            <td>
                                {formatter.format(0)}
                            </td>
                        }                    
                    </tr>  
                    <tr>
                        <td>Total</td>
                        <td>{rows.length}</td>
                        {rows.length > 0 ?
                            <td>
                                {formatter.format(rows.map(el => el.col17).reduce((el, current) => parseFloat(el) + parseFloat(current)))}
                            </td>
                        :
                            <td>
                                {formatter.format(0)}
                            </td>
                        }                    
                    </tr>                 
                </MyTable>
            }               
            <Table 
                rows={rows} 
                columns={columns} 
                cellClick={currentlySelected} 
                rowClassName={rowClassName} 
                components={{
                    Toolbar: GridToolbar,
                }}
            />
            <Snackbar open={error !== ''} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="error">
                    {error}
                </Alert>
            </Snackbar>
        </Container>
    )
}

export default Duplicate;
